import { Props } from '@/lib/makeBooking'
import * as React from 'react'

type Dispatch = (action: Action) => void
type ProviderProps = { children: React.ReactNode }

export const actions = {
  fetching: (sessionId: Props) => ({
    type: 'FETCHING',
    payload: { sessionId },
  }),
  booked: (sessionId: Props) => ({
    type: 'BOOKED',
    payload: { sessionId },
  }),
  failed: (sessionId: Props) => ({
    type: 'FAILED',
    payload: { sessionId },
  }),
}
type Action = { type: 'FETCHING' | 'BOOKED' | 'FAILED'; payload: Partial<Props> }

type State = {
  fetching?: Array<string | undefined>
  booked?: Array<string | undefined>
  failed?: Array<string | undefined>
}

export interface ContextInterface {
  state: State
  dispatch: Dispatch
}

const Context = React.createContext<ContextInterface | undefined>(undefined)

const initialState: State = { fetching: [], booked: [], failed: [] }

function reducer(state: State, action: Action): Partial<State> {
  const newState = state
  switch (action.type) {
    case 'FETCHING': {
      newState.failed = newState.fetching?.filter((e) => e !== action.payload.sessionId)
      newState.fetching?.push(action.payload.sessionId)
      return { ...newState }
    }
    case 'BOOKED': {
      newState.failed = newState.fetching?.filter((e) => e !== action.payload.sessionId)
      newState.fetching = newState.fetching?.filter((e) => e !== action.payload.sessionId)
      newState.booked?.push(action.payload.sessionId)
      return { ...newState }
    }
    case 'FAILED': {
      newState.fetching = newState.fetching?.filter((e) => e !== action.payload.sessionId)
      newState.failed?.push(action.payload.sessionId)
      return { ...newState }
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

function Provider({ children }: ProviderProps): JSX.Element {
  const [state, dispatch] = React.useReducer(reducer, initialState)
  const value = { state, dispatch, actions }
  return <Context.Provider value={value}>{children}</Context.Provider>
}
const BookingProvider = Provider

function useBooking(): ContextInterface {
  const context = React.useContext(Context)
  if (context === undefined) {
    throw new Error('useBooking must be used within a Provider')
  }
  return context
}
export { BookingProvider, useBooking }
